import React from 'react';
import { Link } from 'react-router-dom';
import { SportType } from '@/types';
import SportEmoji from '@/components/SportEmojis';
import { getSportDisplayName } from '@/utils/sportUtils';

interface RelatedSportsNavProps {
  currentSport: SportType;
  className?: string;
}

const allSports: SportType[] = ['nba', 'nfl', 'mlb', 'soccer', 'nhl'];

const RelatedSportsNav: React.FC<RelatedSportsNavProps> = ({ currentSport, className }) => {
  const relatedSports = allSports.filter(sport => sport !== currentSport);

  if (relatedSports.length === 0) return null;

  return (
    <div className={`mt-12 py-8 border-t border-gray-800 ${className}`}>
      <h3 className="text-xl font-semibold text-white mb-4">Explore Other Sports</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {relatedSports.map(sport => (
          <Link
            key={sport}
            to={`/sport/${sport}`}
            className="block p-4 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors group"
          >
            <div className="flex items-center justify-center mb-2">
              <SportEmoji sportType={sport} className="h-8 w-8 text-gray-400 group-hover:text-white" />
            </div>
            <p className="text-center text-sm font-medium text-gray-300 group-hover:text-white">
              {getSportDisplayName(sport)}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedSportsNav; 